import { render, staticRenderFns } from "./CouponsPublishForm.vue?vue&type=template&id=db220eb4&scoped=true&"
import script from "./CouponsPublishForm.vue?vue&type=script&lang=js&"
export * from "./CouponsPublishForm.vue?vue&type=script&lang=js&"
import style0 from "./CouponsPublishForm.vue?vue&type=style&index=0&id=db220eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db220eb4",
  null
  
)

export default component.exports